import * as React from 'react'

interface SectionHeaderProps {
  title: string
  description?: string
  actions?: React.ReactNode
  children?: React.ReactNode
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  description,
  actions,
  children,
}) => (
  <div className="mb-6">
    <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
    {description && (
      <p className="mt-1 text-sm text-gray-500">{description}</p>
    )}
    {actions && (
      <div className="mt-4 flex items-center gap-2">
        {actions}
      </div>
    )}
    {children}
  </div>
)
